import _, { divide } from "lodash";

export default {
  methods: {
    getTextHtml: function(textEng) {
      let texts = textEng.split(" ");

      texts = _.map(
        texts,
        function(text) {
          if (!text.startsWith("b:")) {
            return text;
          }

          let blankCount = parseInt(text.substring(2));
          let blankDivs = [];

          for (let i = 0; i < blankCount; i++) {
            blankDivs.push(":blank");
          }
          return blankDivs;
        }.bind(this)
      );

      let blankIterator = 0;
      return _.chain(texts)
        .flatten()
        .map(
          function(it, key) {
            let item = { value: it, id: "no-id-" + key };
            if (it === ":blank") {
              item.id =
                "englishAnswer_" +
                this.currentPage +
                "_" +
                (key - blankIterator);
              item.index = key - blankIterator;
            } else {
              blankIterator++;
            }
            return item;
          }.bind(this)
        )
        .value();
    },
    shuffleAnswers: function(answers) {
      let _answers = [...answers];
      let shuffledAnswers = [];

      while (shuffledAnswers.length < _answers.length) {
        let randIndex = Math.floor(Math.random() * _answers.length);
        if (!shuffledAnswers.includes(randIndex)) {
          shuffledAnswers.push(randIndex);
        }
      }

      return shuffledAnswers.map(function(index) {
        return _answers[index];
      });
    },
    checkHeaderTitle : function(header){
      let hd = header.split(" ");
			return hd[0];
    },
    selectMultipleItem: function(e, answer, index, qIndex, dropped = false) {
      e.stopPropagation();
      if (e.target.classList.contains("disable") && !dropped) return;

      if (!this.multipleAnswers[this.currentPage])
        this.multipleAnswers[this.currentPage] = [];

      let Q = this.Qs[this.currentPage];
      let userAnsLength = this.Qs[this.currentPage].contents.answers.length; //default answer length is answers from english

      if (
        this.checkHeaderTitle(Q.header)=== "数学" ||
        (Q.header === "すべてのジャンルから解く" &&
         this.checkHeaderTitle(Q.contents.questionHeader) === "数学")
      ){
        let qAns = Q.contents.answer.split(" ");
        userAnsLength = qAns.length; //change answer length if math
        if (qAns.length === this.multipleAnswers[this.currentPage].length)
          return;
      }

      if (
        this.Qs[this.currentPage].contents.answers.length ===
        this.multipleAnswers[this.currentPage].length
      )
        return;

      if (dropped) {
        this.multipleAnswers[this.currentPage] = this.multipleAnswers[
          this.currentPage
        ].filter(function(it) {
          return it.index !== index;
        });
      }

      let nextIndex = this.multipleAnswers[this.currentPage].length;

      if (!dropped) {
        let baseAry = [
          ...Array.from({
            length: this.Qs[this.currentPage].contents.answers.length,
          }).keys(),
        ];
        let answersAry = [
          ...this.multipleAnswers[this.currentPage].map(function(it) {
            return it.index;
          }),
        ];
        baseAry = baseAry.filter(function(it) {
          return !answersAry.includes(it);
        });
        index = Math.min(...baseAry);
      }

      this.multipleAnswers[this.currentPage][nextIndex] = {
        index,
        answer,
        qIndex,
      };

      if (!dropped) e.target.classList.add("disable");

      const answerIndex = index;

      let textHtml = document.getElementById(
        "englishAnswer_" + this.currentPage + "_" + answerIndex
      );

      if (userAnsLength >= this.multipleAnswers[this.currentPage].length) {
        //enable submit button
        this.bool.active_submit = true;
      }

      textHtml.style.color = "rgb(0, 84, 122)";
      textHtml.style.display = "inline";
      textHtml.style.padding = "0 0.25rem";
      textHtml.style.fontSize = "20px";
      textHtml.style.backgroundColor = "white";
      //textHtml.innerHtml = answer;
      
      if (answer.startsWith("img")) {
        const imgName = answer.split(":")[1];
        textHtml.innerHTML = "";
        let imgEl = document.createElement("img");
        imgEl.src = `./answer_images/${this.currentPage}/${imgName}.png`;
        imgEl.style.width = "11%";
        textHtml.appendChild(imgEl);
      } else {

        let ans = answer.split(":");
        if(ans.length > 1){

          answer = ans[0]
        }
        textHtml.innerHTML = answer;
      }
    },
    undoSelection: function() {
      this.bool.show = false;

      const lastIndex = this.multipleAnswers[this.currentPage].length - 1;

      if (lastIndex < 0) return;

      if (lastIndex == 0) {
        this.bool.active_next = false;
        this.bool.active_expl = false;
        this.bool.active_submit = false;
      }

      let ansSelHtml = document.getElementById(
        `engAnsSelection_${this.currentPage}_${
          this.multipleAnswers[this.currentPage][lastIndex].qIndex
        }`
      );
      ansSelHtml.classList.remove("disable");
      let textHtml = document.getElementById(
        "englishAnswer_" +
          this.currentPage +
          "_" +
          this.multipleAnswers[this.currentPage][lastIndex].index
      );
      let el = this.circleElement(
        this.multipleAnswers[this.currentPage][lastIndex].index + 1
      );
      textHtml.innerText = "";
      textHtml.style.color = "white";
      textHtml.style.display = "inline-block";
     // textHtml.style.marginRight = "2px";
      textHtml.style.paddingBottom = "1.2px";
      textHtml.appendChild(el);
     
      this.multipleAnswers[this.currentPage].splice(lastIndex, 1);
    },

    circleElement: function(el) {
      let circle = document.createElement("div");
      circle.style.textAlign = "center";
      circle.style.marginTop = "3px";
      circle.style.marginBottom = "20px";
      circle.style.marginLeft = 'auto';
      circle.style.marginRight = 'auto';
      circle.style.width = "15px";
      circle.style.height = "10px";
      circle.style.paddingTop = '2px'
      circle.style.paddingBottom = '2px'
      circle.style.fontSize = "10px";
      circle.style.borderRadius = "50%";
      circle.style.border = "0.1em solid rgb(102, 102, 102)";
      circle.style.boxSizing = 'initial'
      //circle.style.display = 'inline-block'
      circle.style.left = '0px';
      circle.style.right = '0px';
      circle.textContent = el;
      return circle;
    },

    clearAllSelection: function() {
      const selections = [...this.multipleAnswers[this.currentPage]];
      selections.forEach(
        function() {
          this.undoSelection();
        }.bind(this)
      );

      this.bool.active_next = false;
      this.bool.active_expl = false;
      this.bool.active_submit = false;
    },
    allowDrop: function(ev) {
      ev.preventDefault();
    },
    dragging: function(ev) {
      let selectedItem = document.getElementById(ev.target.id);
      selectedItem.style.backgroundColor = "#cfcfcf"; //grey out selected item
    },
    dragOver: function(ev, item) {
      ev.preventDefault();
      if (!item.id.includes("no")) {
        //don't highlight fixed answers/questions
        let selectedItem = document.getElementById(item.id);
        selectedItem.style.backgroundColor = "#57b3ff"; //change to light blue when about to drop
      }
    },
    dragLeave: function(ev, item) {
      ev.preventDefault();
      let selectedItem = document.getElementById(item.id);
      selectedItem.style.backgroundColor = "white"; //revert back to white
    },
    drag: function(ev, answer, qIndex) {
      let selectedItem = document.getElementById(ev.target.id);
      selectedItem.style.backgroundColor = "#87CEFA"; //highlight selected item
      localStorage.setItem(
        "draggableData",
        JSON.stringify({
          answer,
          id: ev.target.id,
          qIndex,
        })
      );
    },
    dragstop: function(ev) {
      let selectedItem = document.getElementById(ev.target.id);
      selectedItem.style.backgroundColor = "rgba(202, 235, 247, 1)"; //revert back to its original color
      localStorage.removeItem("draggableData");
    },
    drop: function(ev, index) {
      ev.preventDefault();
      let _data = JSON.parse(localStorage.getItem("draggableData"));
      if (!_data) return;
      let { answer, id, qIndex } = _data;
      this.selectMultipleItem(ev, answer, index, qIndex, true);
      this.disableUsedAnswers(id);
      localStorage.removeItem("draggableData");
    },
    disableUsedAnswers: function(id) {
      let answers = this.Qs[this.currentPage].contents.shuffledAnswers;
      let selectedItem = document.getElementById(id);
      selectedItem.classList.add("disable");
      answers.forEach(
        function(ans, key) {

          let usedAnswer = this.multipleAnswers[this.currentPage].find(function(
            it
          ) {
            return it.answer === ans;
          });

          if (!usedAnswer) {
            let unselectedItem = document.getElementById(
              "engAnsSelection_" + this.currentPage + "_" + key
            );
            unselectedItem.classList.remove("disable");
          }
        }.bind(this)
      );
    },
  },
};
